import { render, staticRenderFns } from "./SetImage.vue?vue&type=template&id=5fadfd43"
import script from "./SetImage.vue?vue&type=script&lang=js"
export * from "./SetImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports